/**
 * Build-time configuration. Vite inlines `import.meta.env.VITE_*` at build
 * time, so these are baked into the bundle a Railway service ships. Changing
 * either one is a rebuild, not a restart.
 */
export const config = {
  apiBaseUrl: (import.meta.env.VITE_API_BASE_URL ?? "").replace(/\/+$/, ""),
  privyAppId: import.meta.env.VITE_PRIVY_APP_ID ?? "",
};

/** Names of the env vars that are missing, for the misconfiguration screen. */
export function missingConfig(): string[] {
  const missing: string[] = [];
  if (!config.apiBaseUrl) missing.push("VITE_API_BASE_URL");
  if (!config.privyAppId) missing.push("VITE_PRIVY_APP_ID");
  return missing;
}
